import { ChartsRadialAxisHighlight } from './ChartsRadialAxisHighlight';

export { ChartsRadialAxisHighlight } from './ChartsRadialAxisHighlight';

/**
 * @deprecated radial axis highlight is now stable, import `ChartsRadialAxisHighlight` instead
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Unstable_ChartsRadialAxisHighlight = ChartsRadialAxisHighlight;

export { chartsRadialAxisHighlightClasses } from './chartsRadialAxisHighlightClasses';
export type {
  ChartsRadialAxisHighlightClasses,
  ChartsRadialAxisHighlightClassKey,
} from './chartsRadialAxisHighlightClasses';
export * from './ChartsRadialAxisHighlight.types';
export * from './ChartsRadialAxisHighlightPath';
